import { Door, DoorBatteryWarningLevel, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedUpdateDoorWithLocationsData(updateDoor: Door): Pick<Mutation, 'updateDoor'> {
  return {
    updateDoor
  };
}

export const mockedUpdateDoorWithLocationsDataForMutation = mockedUpdateDoorWithLocationsData(
  generateMockDoor({
    id: 'mockedDoorId0',
    batteryWarningLevel: DoorBatteryWarningLevel.BatteryDefault,
    hardwareIdentifier: '66',
    name: 'mockedDoorNameUpdated'
  })
);

export const mockedAssignDoorToLocationsDataForMutationDoor0 = mockedUpdateDoorWithLocationsData(
  generateMockDoor({ id: 'mockedDoorId0', name: 'door 0' })
);

export const mockedAssignDoorToLocationsDataForMutationDoor1 = mockedUpdateDoorWithLocationsData(
  generateMockDoor({
    id: 'mockedDoorId1',
    name: 'door 1',
    locations: [generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' })]
  })
);

export const mockedAssignDoorToLocationsDataForMutationController1 = mockedUpdateDoorWithLocationsData(
  generateMockDoor({
    id: 'mockedDoorId5',
    name: 'Controller 1',
    locations: [
      generateMockLocation({ id: 'TestGroup2', name: 'Test group 2' }),
      generateMockLocation({ id: 'TestGroup3', name: 'Test group 3' }),
      generateMockLocation({ id: 'TestGroup1', name: 'Test group 1' })
    ]
  })
);
